<div class="add-payment-dialog ks-card">
  <header class="ks-card-header">
    <div class="ks-card-header__title">
      <h2 class="ks-h2 ks-mb-0">Add payment method</h2>
    </div>
    <div class="ks-card-header__tools">
      <div>
        <button
          type="button"
          ktTooltip="Close"
          class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
          (click)="onCancel()"
        >
          <span inlineSVG="assets/icons/Close.svg"></span>
        </button>
      </div>
    </div>
  </header>
  <main class="ks-card-body ks-p-0">
    <div class="ks-stepper">
      <nav class="ks-stepper-tabs ks-mb-10">
        <ng-container *ngFor="let tab of tabs; let idx = index">
          <div [class.active]="idx === activeTabIdx" (click)="activeTabIdx = idx">
            <span
              class="tab-icon-custom svg-icon"
              inlineSVG="assets/media/svg/icons/Payment/{{ tab }}.svg"
            ></span>
            {{ tab }}
          </div>
        </ng-container>
      </nav>
      <div class="ks-stepper-content ks-scrollbar-secondary ks-p-0">
        <div #top>
          <div class="error-message" *ngIf="validationMessage">{{ validationMessage }}</div>
        </div>
        <ng-container [ngSwitch]="activeTabIdx">
          <ng-template ngxPermissionsOnly="canAddCreditCards">
            <kt-bridgepay-credit-card-form
              *ngSwitchCase="tabs.indexOf('Credit Card')"
              [tenantId]="data.organization"
              (formSubmit)="onPaymentAdded($event)"
            >
            </kt-bridgepay-credit-card-form>
          </ng-template>
          <ng-template ngxPermissionsOnly="canAddACHBankTransfer">
            <kt-bridgepay-bank-account-form
              *ngSwitchCase="tabs.indexOf('ACH Bank transfer')"
              [tenantId]="data.organization"
              (formSubmit)="onPaymentAdded($event)"
            >
            </kt-bridgepay-bank-account-form>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </main>

  <div class="dialog-actions">
    <button type="button" class="ks-btn-sm ks-btn-outline-neutral" (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>
